export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "es": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Volver a contenedores"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ver"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Inspecciones de Calidad"])}
        }
      },
      "en": {
        "labels": {
          "go_back_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Back to containers"])},
          "manage_link": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["View"])},
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Quality Templates"])}
        }
      }
    }
  })
}